import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import CheckOutModal from "../CheckOutModal";

const UpgradeYourPlan = () => {
  const analytics = useSelector((state) => state.analytics.data);
  const user = useSelector((state) => state?.user);
  const [showUpgrade, setShowUpgrade] = useState(false);


  const totalCalls = analytics?.totalCalls || 0;
  const totalMinutes = analytics?.totalMinutes?.toFixed(2);


  return (
    <div className='col-xxl-6'>
      <div className='card'>
        <div className='card-body p-20'>
          <div className='row g-3'>
            {/* Left - Buy Credits Box */}
            <div className='col-md-4'>
              <div className='trail-bg h-100 text-center d-flex flex-column justify-content-between align-items-center p-16 radius-8'>
                <h6 className='text-white text-xl'>Boost Your Calling Power</h6>
                <div>
                  <p className='text-white text-sm mb-12'>
                    Top up to avoid service interruption.
                  </p>
                  {/* <a
                    href="mailto:hello@callhq.ai"
                    className="btn py-8 rounded-pill w-100 bg-gradient-blue-warning text-sm"
                  >
                    Contact Us
                  </a> */}
                  <button onClick={() => setShowUpgrade(true)} className="btn py-8 rounded-pill w-100 bg-gradient-blue-warning text-sm">
                    Buy Credit
                  </button>

                </div>
              </div>
            </div>

            {/* Right - Usage Metrics */}
            <div className='col-md-8'>
              <div className='d-flex flex-column gap-3 h-100'>

                {/* Minutes Used */}
                <div className='radius-8 text-center p-20 bg-info-focus w-100'>
                  <span className='w-44-px h-44-px radius-8 d-inline-flex justify-content-center align-items-center text-xl mb-12 bg-info-200 border border-info-400 text-info-600'>
                    <i className='ri-group-3-fill' />
                  </span>
                  <span className='text-neutral-700 d-block'>Minutes Used</span>
                  <h6 className='mb-0 mt-4'>{totalMinutes}</h6>
                </div>

                {/* Number of Calls */}
                <div className='radius-8 text-center p-20 bg-success-100 w-100'>
                  <span className='w-44-px h-44-px radius-8 d-inline-flex justify-content-center align-items-center text-xl mb-12 bg-success-200 border border-success-400 text-success-600'>
                    <i className='ri-phone-find-fill' />
                  </span>
                  <span className='text-neutral-700 d-block'>Number of Calls</span>
                  <h6 className='mb-0 mt-4'>{totalCalls}</h6>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
      <CheckOutModal show={showUpgrade} onClose={() => setShowUpgrade(false)} />
    </div>

  );
};

export default UpgradeYourPlan;
